import type { AdminOrg } from '../lib/types'
import { ListPage } from './list-page'

/** Staff-only `GET /admin/orgs` (server/src/apps/admin). */
export function OrganizationsPage() {
  return (
    <ListPage<AdminOrg>
      title="Organizations"
      description="Every tenant on Farmula."
      path="/admin/orgs"
      noun="organizations"
      columns={[
        { header: 'Name', primary: true, cell: (o) => o.name },
        { header: 'Slug', cell: (o) => o.slug },
        { header: 'Members', cell: (o) => o.memberCount ?? '—' },
        { header: 'Farms', cell: (o) => o.farmCount ?? '—' },
        { header: 'Created', cell: (o) => new Date(o.createdAt).toLocaleDateString() },
      ]}
    />
  )
}
